import DismissibleFormWrapper from '../DismissibleFormWrapper';
import { SimpleResourceCategory } from '../../types';
import CategoryForm from './CategoryForm';

interface CategoryFormFactoryProps {
    onClose: () => void;
    onSubmit: () => void;
    opened: boolean;
    initialValues?: SimpleResourceCategory;
}

const categoryFormFactory =
    ({ headerButtonTextKey }: { headerButtonTextKey: Mews.TextKey }) =>
    ({ onClose, onSubmit, opened, initialValues }: CategoryFormFactoryProps) => (
        <DismissibleFormWrapper onClose={onClose} opened={opened} headerButtonTextKey={headerButtonTextKey}>
            <CategoryForm initialValues={initialValues} form="category-form" onSubmit={onSubmit} />
        </DismissibleFormWrapper>
    );

export default categoryFormFactory;
